// Types
import { JWTData } from '../../types/jwtData';
import { RegistrationData } from '../../types/registrationData';

// Function to sign up a user
export const signUp = async (registrationData: RegistrationData): Promise<boolean> => {
    try {
        const response = await fetch((process.env.REACT_APP_QW_API_URL as string) + '/groups/signeval', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-AUTH-TOKEN': process.env.REACT_APP_QW_API_TOKEN as string
            },
            body: JSON.stringify(registrationData)
        });

        if (response.ok) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error signing up:', error);
        return false;
    }
};

// Function to get jwt token
export const getJwt = async (email: string, password: string): Promise<JWTData | null> => {
    const body = new URLSearchParams();
    body.append('email', email);
    body.append('pwd', password);

    try {
        const response = await fetch((process.env.REACT_APP_QBC_API_URL as string) + '/openid-connect/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
        });

        const data = await response.json();

        if (!data.access_token || !data.refresh_token || !data.expires_in || !data.refresh_expires_in) {
            return null;
        }

        const jwt: JWTData = {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            expires_in: data.expires_in,
            refresh_expires_in: data.refresh_expires_in
        };

        return jwt;
    } catch (error) {
        console.error('Error logging in:', error);
        return null;
    }
};

export const refreshToken = async (refresh_token: string): Promise<JWTData | null> => {
    const body = new URLSearchParams();
    body.append('refresh_token', refresh_token);

    try {
        const response = await fetch((process.env.REACT_APP_QBC_API_URL as string) + '/openid-connect/refresh', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
        });

        const data = await response.json();
        const jwt: JWTData = {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            expires_in: data.expires_in,
            refresh_expires_in: data.refresh_expires_in
        };

        return jwt;
    } catch (error) {
        console.error('Error refreshing token:', error);
        return null;
    }
};
